<template>
  <div>
    <v-navigation-drawer v-model="drawer" app temporary right disable-resize-watcher>
      <v-list>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
          </v-list-item-avatar>
        </v-list-item>

        <v-list-item link>
          <v-list-item-content>
            <v-list-item-title class="title">{{this.$store.state.user.name}}</v-list-item-title>
            <v-list-item-subtitle>{{this.$store.state.user.email}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item link v-for="item in items" :key="item.title" :to="item.link">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar fixed color="green" app dark dense>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-app-bar-nav-icon @click="drawer = !drawer" v-on="on"></v-app-bar-nav-icon>
        </template>
        <span>منو</span>
      </v-tooltip>
      <v-toolbar-title>کلمات</v-toolbar-title>

      <v-spacer></v-spacer>

<!--      <v-switch v-model="$vuetify.theme.dark" hide-details inset></v-switch>-->

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon @click="logout" v-on="on">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>خروج</span>
      </v-tooltip>
    </v-app-bar>
     <v-main>
        <v-container >
          <router-view/>
        </v-container>
     </v-main>
    <v-footer padless app>
      <v-card class="flex" flat tile>
        <v-progress-linear :active="this.$store.state.words.loading" :indeterminate="this.$store.state.words.loading" absolute top color="lime"></v-progress-linear>
        <v-card-title class="teal text-center justify-center py-2">
          <v-pagination color="green"
            v-model="$store.state.words.page"
            :length="$store.state.words.total_pages"
            :page="$store.state.words.page"
            :total-visible="5"/>
        </v-card-title>
      </v-card>
    </v-footer>
  </div>
</template>
<script>
export default {
  name: 'Home',

  components: {},

  data: () => ({
    collapseOnScroll: true,
    drawer: null,
    mini: null,
    right: true,
    icons: [
      'mdi-telegram'
    ],
    items: [
      {
        title: 'خانه',
        icon: 'mdi-view-dashboard',
        link: '/'
      },
      {
        title: 'درباره ما',
        icon: 'mdi-information',
        link: '/about'
      }
    ]
  }),
  mounted () {
    this.$store.commit('loadUserProfile')
  },
  methods: {
    logout () {
      this.$store.commit('logout')
    }
  }
}
</script>
